export default "__VITE_ASSET__Bomlf34f__"